import React from "react";
import Header from "components/Header/Header";
import FaqSection from "components/Faq/FaqSection";
import FaqAccordion from "components/Faq/FaqAccordion";
import ContactUsSection from "components/ContactUsSection/ContactUsSection";
import Footer from "components/Footer/Footer";

const FaqPage = () => {
    return (
        <div className='overlay'>
            <Header />
            <FaqSection />
            <FaqAccordion />
            <ContactUsSection />
            <Footer />
        </div>
    );
};

export default FaqPage;